import React, { useState, forwardRef, createRef, useEffect } from "react";
// We neeed to use this deprecated module for now until expo fixes release channels
import { StyleSheet, Keyboard, View, TouchableOpacity, Platform } from "react-native";
import { Picker } from "@react-native-picker/picker";
import { TextInput } from "ui-components";
import { IDropdownProps } from "../../dropdown/dropdown";
import moment from "moment";
import { Modal } from "ui-components";
import { TouchableOpacity as TouchableOpacityGesture } from "react-native-gesture-handler";
import Auryc from "rn-auryc-sdk";

const DEFAULT_VALUE = "default";

export const MonthYearDropdownNew = forwardRef((props: IDropdownProps, ref: any) => {
  const { formName, setValue, errors, inputAccessoryViewID, onFocus, onSubmitEditing, value } =
    props;
  const [selectedMonth, setSelectedMonth] = useState(DEFAULT_VALUE);
  const [selectedYear, setSelectedYear] = useState(DEFAULT_VALUE);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isPickerVisible, setPickerVisible] = useState(false);
  const isYearSelected = selectedYear !== DEFAULT_VALUE;
  const isMonthSelected = selectedMonth !== DEFAULT_VALUE;
  const modalRef = createRef();
  const TouchableComponent =
    Platform.OS == "android" || Platform.OS == "web" ? TouchableOpacity : TouchableOpacityGesture;

  useEffect(() => {
    if (value) {
      //When there is an api error we don't want to reset preselected month and year from picker.
      //Value will be used as default when present e.g 0423 that reperesents April 2023.
      const month = Number(value.slice(0, 2)) - 1;
      const year = Number(value.slice(2, 4)) + 2000;
      setSelectedMonth(month);
      setSelectedYear(year.toString());
    } else {
      //When parent component is closed parent state gets reseted but this components is managing
      //its own local state that needs to also be reseted.
      setSelectedMonth(DEFAULT_VALUE);
      setSelectedYear(DEFAULT_VALUE);
    }
  }); //Do not add [] effect needs to be called on every render.

  const onSelectMonthHandler = (monthValue: any) => {
    if (monthValue === DEFAULT_VALUE) return;
    const date = moment();
    const year = isYearSelected ? selectedYear : date.year();
    date.month(monthValue);
    date.year(year);
    setValue(formName, date);
    setSelectedMonth(monthValue);
    setSelectedDate(date);
    if (!isYearSelected) {
      setSelectedYear(year.toString());
    }
  };

  const onSelectYearHandler = (yearValue: any) => {
    if (yearValue === DEFAULT_VALUE) return;
    const date = moment();
    const month = isMonthSelected ? selectedMonth : date.month();
    date.year(yearValue);
    date.month(month);
    setValue(formName, date);
    setSelectedYear(yearValue);
    setSelectedDate(date);
    if (!isMonthSelected) {
      setSelectedMonth(month);
    }
  };

  const styles = StyleSheet.create({
    modalContainer: {
      display: "flex",
      borderRadius: 10,
      flexDirection: "row",
      justifyContent: "center",
    },
    picker: {
      width: "50%",
      padding: 15,
      outlineStyle: "none",
    },
    textInput: {},
  });

  const months = Array.from(new Array(12)).map((v, index) => ({ value: index, key: index }));
  const years = Array.from(new Array(30)).map((v, index) => ({
    value: String(2020 + index),
    key: index,
  }));

  const formattedDate = selectedDate ? selectedDate.format("MMM YYYY") : value;

  return (
    <>
      <Modal
        ref={modalRef}
        showCloseIcon={true}
        containerStyle={{ maxWidth: 400 }}
        testID={formName + "-modal"}>
        <View style={styles.modalContainer} ref={(x) => Auryc.markViewAsSensitiveInformation(x)}>
          <Picker
            mode="dropdown"
            selectedValue={selectedMonth}
            style={styles.picker}
            onValueChange={onSelectMonthHandler}
            testID={formName + "-month-picker"}
            accessibilityLabel={formName + "-month-picker"}>
            <Picker.Item value={DEFAULT_VALUE} label="Month" />
            {months.map(({ value }, index) => {
              return <Picker.Item key={index} value={value} label={getMonthLabel(value)} />;
            })}
          </Picker>
          <Picker
            mode="dropdown"
            selectedValue={selectedYear}
            style={styles.picker}
            onValueChange={onSelectYearHandler}
            testID={formName + "-year-picker"}
            accessibilityLabel={formName + "-year-picker"}>
            <Picker.Item value={DEFAULT_VALUE} label="Year" />
            {years.map(({ value }, index) => {
              return <Picker.Item key={index} value={value} label={value} />;
            })}
          </Picker>
        </View>
      </Modal>
      <TouchableComponent
        activeOpacity={0.8}
        onPress={() => modalRef.current.open()}
        style={{ outlineStyle: "none" }}
        testID={props.testID + "-button"}
        accessibilityLabel={props.accessibilityLabel + " button"}>
        <TextInput
          label={props.title}
          labelStyle={{ fontFamily: "Lato_700Bold" }}
          style={styles.textInput}
          value={formattedDate}
          // iconName="calendar-blank-outline"
          error={errors?.[formName]}
          mode="outlined"
          inputAccessoryViewID={inputAccessoryViewID}
          onSubmitEditing={onSubmitEditing}
          placeholder={"mm/yyyy"}
          ref={ref}
          editable={false}
          testID={props.testID || props.accessibilityLabel}
          accessibilityLabel={props.accessibilityLabel || props.testID}
          dataSet={props.dataSet}
        />
      </TouchableComponent>
    </>
  );
});

const getMonthLabel = (monthNum: number) => {
  const date = moment();
  date.month(monthNum);
  return date.format("M MMM");
};
